export default "__VITE_ASSET__CeVec$Tx__"